import { BASE_URL } from './apiHelper';

export const LOGOUT_URL = `${BASE_URL}/logout`;

export const redirectToLogin = () => {
    window.location.replace(`${process.env.REACT_APP_DILIGENCE_LOGIN_URL}`);
};